import { render, staticRenderFns } from "./Page3.vue?vue&type=template&id=13185bb2&scoped=true&"
import script from "./Page3.vue?vue&type=script&lang=ts&"
export * from "./Page3.vue?vue&type=script&lang=ts&"
import style0 from "./Page3.vue?vue&type=style&index=0&id=13185bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13185bb2",
  null
  
)

export default component.exports